/**
 * Handles modifications to Suggestion results
 */
//var SuggestPortalExtension = (function() {
define(['jquery', 'c21/ajax'], function ($, ajax) {
   "use strict";

   var m_jSearchDrop, m_iHighlightedIndex, m_jResults,
      m_portalSearch, m_strBehindText, m_strText;

   /**
    * For a given item in the list, find the text
    * @return {string} ex: "New York, NY"
    */
   function getItemText(jItem) {
      var jItemName = (jItem.hasClass('suggestCollapse') || jItem.hasClass('ftsCollapse')) ? jItem : jItem.find('.suggestCollapse,.ftsCollapse').eq(0),
         // Collapsasaurus will collapse the HTML and set the title,
         // but it doesn't necessarily happen before this is called
         str = jItemName.attr('title') || jItemName.html();
      return str;
   }

   /**
    * Get a sensible name for the type of drop-down being displayed
    * @return {String}
    */
   function getDropDownType() {
      var strSuggestType = (window.fts) ? window.fts.suggestType : "";
      switch (strSuggestType) {
         case "NO_SUGGEST":
            return 'suggest';

         case "SINGLE_LOCATION":
            return "result";

         case "NO_RESULT":
            return "noresults";

         // FIXME: What is the text for a disambiguation page?
         default:
            return "disambiguation";
      }
   }

   function setBehindText (strBehindText) {
      m_strBehindText = strBehindText;
      if (m_portalSearch) {
         m_portalSearch.setBehindText(strBehindText);
      }
   }
   
   function setText (strText) {
      m_strText = strText;
      if (m_portalSearch) {
         m_portalSearch.setText(strText);
      }
   }
   
   /**
    * Highlight the item at the specified index
    * @param i the index to highlight
    */   
   function setHighlightedIndex(iHighlightedIndex, bUpdateText) {
      var jItem = m_jResults.eq(iHighlightedIndex),
         strNewText = getItemText(jItem);
   
      if (strNewText) {
         strNewText = $.trim(strNewText.split("|")[0]);
      }
      m_jResults.eq(m_iHighlightedIndex).removeClass('hover');
      jItem.addClass('hover');
      m_iHighlightedIndex = iHighlightedIndex;
         
      setBehindText(strNewText);
      
      if (bUpdateText) {
         setText(strNewText);
      }
   }
   
   /**
    * Get the index of the currently highlighted item
    */
   function getHighlightedIndex() {
      return m_iHighlightedIndex;
   }

   /**
    * When the "Suggest" section is loaded
    */   
   function onSuggestLoad() {
      var jItem;

      // Highlight every other item
      m_jResults = m_jSearchDrop.find('#ftsSearchBody .result');
         
      m_jResults.hover(function() {
         setHighlightedIndex(m_jResults.index($(this)));
      }, function() {
         $(this).removeClass('hover');
      });
      
      m_iHighlightedIndex = -1;
      
      if (m_jResults.length > 0) {
         jItem = m_jResults.eq(0);
         setBehindText(getItemText(jItem));
      } else {
         jItem = m_jSearchDrop.find('#singleSearchMatch');
         setBehindText(jItem.text());
      }

      // Disabled in ECO and IDX
      /*
      $("#bedrooms").c21dropdown({
         maxLength: 2,
         tabIndex: 102,
         dropdownClass: 'dropdownCustomizations',
         selectBoxClass: 'selectorCustomizations',
         baseName: 'bedrooms'
      });

      $("#bathrooms").c21dropdown({
         maxLength: 2,
         tabIndex: 104,
         dropdownClass: 'dropdownCustomizations',
         selectBoxClass: 'selectorCustomizations',
         baseName: 'bathrooms'
      });

      $("#structureSize").c21dropdown({
         maxLength: 7,
         tabIndex: 106,
         dropdownClass: 'dropdownCustomizations',
         selectBoxClass: 'selectorSquareFeet',
         baseName: 'structureSize'
      });

      var jPriceOptions = $("#priceOptions"),
         jDropdown = $("#dropdownSearchContent");

      $("#priceFrom").c21textdropdown(jPriceOptions, {
         maxLength: 10,
         tabIndex: 100,
         dropdownClass: 'dropdownCustomizations dropdownPrice',
         selectBoxClass: 'priceBox',
         parentNode: jDropdown,
         textHint: internationalization.getString('Minimum')
      });

      $("#priceTo").c21textdropdown(jPriceOptions, {
         maxLength: 10,
         tabIndex: 101,
         dropdownClass: 'dropdownCustomizations dropdownPrice',
         selectBoxClass: 'priceBox',
         parentNode: jDropdown,
         textHint: internationalization.getString('Maximum')
      });
      */
   }

   /**
    * When the document is ready
    */
   function onDocumentReady() {
      m_jSearchDrop = $('#ftsDropdownContent');
      ajax.bindLoadEvent(m_jSearchDrop, onSuggestLoad);
   }  
      
   $(document).ready(onDocumentReady);

   return {
      initPortalSearch: function (portalSearch) {
         m_portalSearch = portalSearch;
         if (m_strBehindText) m_portalSearch.setBehindText(m_strBehindText);
         if (m_strText) m_portalSearch.setText(m_strText);
      },

      moveUp: function() {
         if (getDropDownType() !== 'suggest')
            return;

         var i = getHighlightedIndex() - 1;
      
         if (i < 0) {
            i = m_jResults.length - 1;
         }
         
         setHighlightedIndex(i, true);
      }, 
      
      moveDown: function() {
         if (getDropDownType() !== 'suggest')
            return;

         var i = getHighlightedIndex() + 1;
         
         if (i === m_jResults.length) {
            i = 0; 
         }
      
         setHighlightedIndex(i, true);
      }
   };
});
